import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/VIPMP/VIPMP/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "support"
    }}>{`Support`}</h1>
    <p>{`The following support resources are available in case of any issues.`}</p>
    <h2 {...{
      "id": "contact-information"
    }}>{`Contact information`}</h2>
    <p>{`For details on the support path and contact information, refer to `}<a parentName="p" {...{
        "href": "https://cbconnection.adobe.com/en/vip-marketplace-guide/support-resources"
      }}>{`VIP Marketplace support`}</a>{`.`}</p>
    <h2 {...{
      "id": "references"
    }}>{`References`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobelaunch.com/api/guides/access_tokens/"
        }}>{`IMS access tokens`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/authentication/auth-methods.html#!AdobeDocs/adobeio-auth/master/JWT/JWT.md"
        }}>{`JWT authentication workflow`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://helpx.adobe.com/adobe-io/tutorials.html"
        }}>{`Adobe I/O tutorials`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://jwt.io/"
        }}>{`JWT libraries and SDKs`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      